




import { Component } from 'vue-property-decorator'

// mixins
import VKIDMixin from '@/mixins/VKIDMixin'

@Component
export default class VKCart extends VKIDMixin {
  private mounted() {
    // Тут был редирект на VUE_APP_BACKEND_API_ENDPOINT/payment/orders/${uuid}/pay?${query}`
    // this.vkCart()

    // Тут редирект на ЛК корзину
    this.vkCartRedirectToAccountCart()
  }
}
